export enum UserRoleName {
  Admin = 'admin',
  User = 'user',
  HotelAdmin = 'hotel_admin',
  HotelUser = 'hotel_user',
  Receptionist = 'receptionist',
  LogisticsPartner = 'logistics_partner',
}

export enum UserCapability {
  GuestData = 'guest_data',
  ShowHiddenTags = 'show_hidden_tags',
}

export enum UserStatus {
  Active = 'active',
  Invited = 'invited',
  Disabled = 'disabled',
}

export enum UserScope {
  AllHotels = 'all-hotels',
  ThisHotel = 'this-hotel',
  Suitepad = 'suitepad',
}

export const DEFAULT_SORT_PER_SCOPE = {
  [UserScope.AllHotels]: 'hotelIds',
  [UserScope.ThisHotel]: 'roles',
  [UserScope.Suitepad]: 'roles',
};

export const USER_SCOPES = [
  UserScope.AllHotels,
  UserScope.ThisHotel,
  UserScope.Suitepad,
];

export const HOTEL_USER_SCOPES = [UserScope.AllHotels, UserScope.ThisHotel];

export const HOTEL_USER_ROLES = [
  UserRoleName.HotelAdmin,
  UserRoleName.HotelUser,
  UserRoleName.Receptionist,
];

export const SUITEPAD_ROLES = [UserRoleName.Admin, UserRoleName.User];

export const USER_ROLE_I18N_KEY: Record<UserRoleName, string> = {
  [UserRoleName.Admin]: 'admin',
  [UserRoleName.User]: 'user',
  [UserRoleName.HotelAdmin]: 'hotel-admin',
  [UserRoleName.HotelUser]: 'hotel-user',
  [UserRoleName.Receptionist]: 'receptionist',
  [UserRoleName.LogisticsPartner]: 'logistics-partner',
};

export const ROLE_CAPABILITIES: Record<UserRoleName, UserCapability[]> = {
  [UserRoleName.Admin]: [
    UserCapability.GuestData,
    UserCapability.ShowHiddenTags,
  ],
  [UserRoleName.User]: [
    UserCapability.GuestData,
    UserCapability.ShowHiddenTags,
  ],
  [UserRoleName.HotelAdmin]: [UserCapability.GuestData],
  [UserRoleName.HotelUser]: [UserCapability.GuestData],
  [UserRoleName.Receptionist]: [UserCapability.GuestData],
  [UserRoleName.LogisticsPartner]: [],
};

export const USER_MANAGER_ROLES = [
  UserRoleName.Admin,
  UserRoleName.User,
  UserRoleName.HotelAdmin,
];
